const parseError = (errorObj = {}) => {
    let errorMsg = [];
    for (const key in errorObj) {
        if (errorObj.hasOwnProperty(key)) {
            errorMsg.push(errorObj[key]);
        }
    }
    return errorMsg;
}
export { parseError };